import React from "react";
import style from "./index.module.scss";
import { Button } from "antd";
import className from "classnames";
import { TopicsItem } from "../../../service";
import useDeviceType from "../../../../../../Utils/useDeviceType";
import classNames from "classnames";
import { isTrue } from "../../../../../../Utils/filter";

interface QuestionnaireBarProps {
    checked: number;
    data: TopicsItem[];
    onChange: (val: number) => void;
    onClose?: () => void;
}

export default function QuestionnaireBar({
    checked,
    data,
    onChange,
    onClose
}: QuestionnaireBarProps) {
    const { isPC } = useDeviceType();

    return (
        <div className={style.root}>
            <div className={style.top}>
                <div className={style.title}>全部试题</div>

                <div className={style.icons}>
                    <span className={style.iconNone}>未答</span>
                    <span className={style.iconRight}>已答</span>
                </div>
            </div>

            <div className={classNames({ [style.body]: !isPC })}>
                <ul className={style.qidList}>
                    {data &&
                        data.map((item, index) => (
                            <li
                                onClick={() => onChange(item.index)}
                                key={index}
                                className={className(style.qidItem, {
                                    [style.current]: item.index === checked,
                                    [style.right]: item.stuFinishTopic === "1"
                                })}>
                                {isTrue(item.requiredFlag) && (
                                    <span className="required_overflow" />
                                )}
                                {item.index}
                            </li>
                        ))}
                </ul>
            </div>

            {!isPC && (
                <div className={style.footer}>
                    <Button block className={style.btn} onClick={onClose}>
                        返回
                    </Button>
                </div>
            )}
        </div>
    );
}
